import { Box } from '@mui/material';
import ConfirmSubmitDialog from './ConfirmSubmitDialog';
import { useConfirmDialog } from '../../../../../../hooks/useConfirmDialog';

function getAccountDisabledMessage() {
  return (
    <>
      <Box>This account is disabled for invoices.</Box>
      <Box>All future invoices for this account will be ignored.</Box>
      <Box>Please check with the facility to ensure they are still expecting the remaining invoices.</Box>
    </>
  );
}

export function useAccountDisabledNotification(onConfirm) {
  const dialog = useConfirmDialog();

  const element = dialog.isOpen ? (
    <ConfirmSubmitDialog
      title="Disabled Account"
      content={getAccountDisabledMessage()}
      handleCloseSubmitDialog={dialog.close}
      onConfirmSubmit={onConfirm}
    />
  ) : null;

  return { open: dialog.open, element };
}
